// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/lrr-schema',
  type: 'object',
  required: [],
  nullable: true,
  properties: {
    chain: {
      type: 'integer',
      nullable: true,
    },
    lrrESP: {
      type: 'number',
      nullable: true,
    },
    lrrRSSI: {
      type: 'integer',
      nullable: true,
    },
    lrrSNR: {
      type: 'number',
      nullable: true,
    },
    lrrid: {
      type: 'string',
      nullable: true,
    },
  },
} as IJSONSchema;

export default schema;
